/**
 * IssuesWorkToolbar — Suche, Sortierung, Sales-Daten-Badge oberhalb der Arbeitsliste.
 * Ausgelagert aus IssuesPage (100-Zeilen-Limit), P4-Task 12.
 */
import { useTranslation } from 'react-i18next'
import { Input } from '@/components/v2/ui'
import type { ProductWithIssues } from '@/lib/api/channel-readiness'
import type { IssuesSort } from '@/hooks/useIssuesFilters'
import { SalesDataBadge } from './SalesDataBadge'

const SORTS: IssuesSort[] = ['impact_desc', 'count_desc', 'count_asc', 'name_asc']
const SORT_KEY: Record<IssuesSort, string> = {
  impact_desc: 'sortImpactDesc',
  count_desc: 'sortCountDesc',
  count_asc: 'sortCountAsc',
  name_asc: 'sortNameAsc',
}

interface IssuesWorkToolbarProps {
  search: string
  onSearchChange: (v: string) => void
  sort: IssuesSort
  onSortChange: (v: IssuesSort) => void
  products: ProductWithIssues[]
}

export function IssuesWorkToolbar(props: IssuesWorkToolbarProps) {
  const { t } = useTranslation()
  return (
    <div className="flex flex-wrap items-center gap-2">
      <Input
        value={props.search}
        onChange={(e) => props.onSearchChange(e.target.value)}
        placeholder={t('productsIssues.workList.searchPlaceholder')}
        data-testid="issues-search"
        className="max-w-xs"
      />
      <label className="flex items-center gap-1.5 text-sm text-neutral-500">
        {t('productsIssues.workList.sort')}
        <select
          value={props.sort}
          onChange={(e) => props.onSortChange(e.target.value as IssuesSort)}
          data-testid="issues-sort"
          className="rounded-md border border-neutral-300 bg-white px-2 py-1 text-sm dark:border-neutral-700 dark:bg-neutral-900"
        >
          {SORTS.map((s) => (
            <option key={s} value={s}>
              {t(`productsIssues.workList.${SORT_KEY[s]}`)}
            </option>
          ))}
        </select>
      </label>
      <SalesDataBadge products={props.products} />
    </div>
  )
}
